import store from "../../store";

export const initEditorState = (editorState, section) => dispatch => {
  dispatch({
    type: "INIT_EDITOR_STATE",
    payload: { editorState, section },
  });
};

export const updateEditorState = editorState => dispatch => {
  dispatch({ type: "UPDATE_EDITOR_STATE", payload: editorState });
};

export const updateEditorStateIfActive = (editorState, id) => dispatch => {
  dispatch({
    type: "UPDATE_EDITOR_STATE_IF_ACTIVE",
    payload: { editorState, id },
  });
};

export const nukeEditorState = isConditional => dispatch => {
  if (isConditional) {
    const reduxState = store.getState();
    const { clickedEditorState, clickedSection } = reduxState.EditorStore;
    if (clickedSection || clickedEditorState) {
      dispatch({ type: "NUKE_EDITOR_STATE" });
    }
  } else {
    dispatch({ type: "NUKE_EDITOR_STATE" });
  }
};

export const updateEditorCurrentClickedSection = section => dispatch => {
  dispatch({ type: "UPDATE_EDITOR_CURRENT_CLICKED_SECTION", payload: section });
};

export const updateEditorHighlightSelection = highlightedContent => dispatch => {
  dispatch({
    type: "UPDATE_EDITOR_HIGHLIGHT_SELECTION",
    payload: highlightedContent,
  });
};



// WEBPACK FOOTER //
// ./src/actions/EditorActions/editorActions.js